import { render, staticRenderFns } from "./MenuModifiers.vue?vue&type=template&id=e83c720e&"
import script from "./MenuModifiers.vue?vue&type=script&lang=js&"
export * from "./MenuModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports